import { useState } from 'react';
import { ChatUnreadCountContext, SetChatUnreadCountContext } from './chatUnreadContexts.js';

export function ChatUnreadProvider({ children }) {
  const [totalUnread, setTotalUnread] = useState(0);

  return (
    <ChatUnreadCountContext.Provider value={totalUnread}>
      <SetChatUnreadCountContext.Provider value={setTotalUnread}>
        {children}
      </SetChatUnreadCountContext.Provider>
    </ChatUnreadCountContext.Provider>
  );
}
